import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RegisterForm from "../components/RegisterForm/RegisterForm";

const ClubsList = () => {
  const [clubs, setClubs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClubs = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clubs`);
        const data = await res.json();
        if (res.ok) setClubs(data);
        else console.error("Fetch error:", data.message);
      } catch (err) {
        console.error("Server error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClubs();
  }, []);

  const filteredClubs = clubs.filter(club =>
    club.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <section className="min-h-screen bg-gray-50 py-10 px-4">
      <h1 className="text-3xl font-bold text-center mb-6">Clubs Listing</h1>

      {/* 🔍 Search Bar */}
      <div className="max-w-md mx-auto mb-8">
        <input
          type="text"
          placeholder="Search clubs..."
          className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* 🔗 Search Results (Name + Link only) */}
      {searchQuery && (
        <div className="max-w-2xl mx-auto mb-8">
          <h2 className="text-lg font-semibold mb-2">Search Results:</h2>
          {filteredClubs.length > 0 ? (
            <ul className="space-y-2">
              {filteredClubs.map((club) => (
                <li key={club.id}>
                  <Link to={`/${club.slug}`} className="text-blue-600 hover:underline">
                    {club.name}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No clubs found.</p>
          )}
        </div>
      )}

      {/* 🧾 Club Registration Form */}
      <div className="max-w-3xl mx-auto bg-white p-6 rounded shadow-md mb-12">        
        <RegisterForm />
      </div>

      
      {/* 🕑 Loading State */}
      {loading && (
        <p className="text-center text-gray-500">Loading...</p>
      )}
    </section>
  );
};

export default ClubsList;
